import { useTranslation } from "react-i18next";
import { Skeleton } from "@/components/ui/skeleton";

/** Rows to fake per section — matches the real lists' typical length. */
const SECTION_ROWS = [3, 3];

/**
 * Shown while the profile request is in flight. Mirrors the real layout's
 * metrics so nothing shifts when the data lands.
 */
export const ProfileDrawerSkeleton = () => {
  const { t } = useTranslation(["common"]);
  return (
    <div
      className="space-y-5"
      aria-busy
      aria-label={t("common:a11y.loading_your_profile")}
    >
      {/* Metrics track ProfileIdentityCard exactly — including the 2px gradient
        ring around the avatar (size-14 + p-0.5 = 60px) — so nothing jumps. */}
      <div className="flex items-center gap-3.5 rounded-sm bg-profile-drawer-user p-3.5">
        <Skeleton soft className="size-15 rounded" />
        <div className="flex-1 space-y-2">
          <Skeleton soft className="h-4 w-40" />
          <Skeleton soft className="h-3 w-24" />
          <Skeleton soft className="h-5 w-20 rounded-xs" />
        </div>
      </div>

      {SECTION_ROWS.map((rows, section) => (
        <div key={section} className="space-y-2">
          <Skeleton className="h-3 w-28" />
          <div className="divide-y divide-border overflow-hidden rounded-sm border border-border">
            {Array.from({ length: rows }).map((_, row) => (
              <div key={row} className="flex items-center gap-3 px-3 py-3">
                <Skeleton className="size-8 rounded-xxs" />
                <div className="flex-1 space-y-1.5">
                  <Skeleton className="h-2.5 w-16" />
                  <Skeleton className="h-3 w-36" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
